/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} Interview_Practice_Question_ProgressInputs */

const en_interview_practice_question_progress = /** @type {(inputs: Interview_Practice_Question_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Question ${i?.current} of ${i?.total}`)
};

const de_interview_practice_question_progress = /** @type {(inputs: Interview_Practice_Question_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Frage ${i?.current} von ${i?.total}`)
};

const fr_interview_practice_question_progress = /** @type {(inputs: Interview_Practice_Question_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Question ${i?.current} sur ${i?.total}`)
};

const es_interview_practice_question_progress = /** @type {(inputs: Interview_Practice_Question_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pregunta ${i?.current} de ${i?.total}`)
};

const it_interview_practice_question_progress = /** @type {(inputs: Interview_Practice_Question_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Domanda ${i?.current} di ${i?.total}`)
};

const nl_interview_practice_question_progress = /** @type {(inputs: Interview_Practice_Question_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vraag ${i?.current} van ${i?.total}`)
};

const pl_interview_practice_question_progress = /** @type {(inputs: Interview_Practice_Question_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pytanie ${i?.current} z ${i?.total}`)
};

const fi_interview_practice_question_progress = /** @type {(inputs: Interview_Practice_Question_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kysymys ${i?.current} / ${i?.total}`)
};

const da_interview_practice_question_progress = /** @type {(inputs: Interview_Practice_Question_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Spørgsmål ${i?.current} af ${i?.total}`)
};

const sv_interview_practice_question_progress = /** @type {(inputs: Interview_Practice_Question_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fråga ${i?.current} av ${i?.total}`)
};

/**
* | output |
* | --- |
* | "Question {current} of {total}" |
*
* @param {Interview_Practice_Question_ProgressInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_practice_question_progress = /** @type {((inputs: Interview_Practice_Question_ProgressInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Practice_Question_ProgressInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_practice_question_progress(inputs)
	if (locale === "fr") return fr_interview_practice_question_progress(inputs)
	if (locale === "es") return es_interview_practice_question_progress(inputs)
	if (locale === "it") return it_interview_practice_question_progress(inputs)
	if (locale === "nl") return nl_interview_practice_question_progress(inputs)
	if (locale === "pl") return pl_interview_practice_question_progress(inputs)
	if (locale === "fi") return fi_interview_practice_question_progress(inputs)
	if (locale === "da") return da_interview_practice_question_progress(inputs)
	if (locale === "sv") return sv_interview_practice_question_progress(inputs)
	return en_interview_practice_question_progress(inputs)
});